import { createStore } from "vuex";
import axios from "axios";

//import router from "@/router";

const store = new createStore({
  state: {
    user: {
      email: "",
      password: "",
      isAuthenticated: false,
    },
    allConversations: [],
    specificConversation:[],
    iframeProperty: {
      isLoaded: false,
      layout: 'window',
      headerTitle: '',
      headerDescription: '',
      buttonTextColour: '',
      buttonBackgroundColour: '',
      maximumConversationTurn: null,
    },
  },
  getters: {
    currentUser(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    getAllConversations(state) {
      return state.allConversations;
    },
    getSpecificConversation(state) {
      return state.specificConversation;
    },
  },
  mutations: {
    SET_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    SET_SIGNUP() {
      console.log("User signed up successfully!")
    },
    SET_ALL_CONVERSATIONS(state, allConversations) {
      state.allConversations = allConversations;
    },
     SET_SPECIFIC_CONVERSATION(state, specificConversation) {
      state.specificConversation = specificConversation;
    },
    SET_IFRAME_PROPERTIES(state, iframePropertyResponse) {
      state.iframeProperty = {
        isLoaded: true,
        layout: iframePropertyResponse.data.layout,
        headerTitle: iframePropertyResponse.data.chatbot_header_title,
        headerDescription: iframePropertyResponse.data.chatbot_header_description,
        buttonTextColour: iframePropertyResponse.data.button_text_colour,
        buttonBackgroundColour: iframePropertyResponse.data.button_background_colour,
        maximumConversationTurn: iframePropertyResponse.data.maximum_conversation_turn,
      };
    },
    SET_CONVERSATION_SUMMARY(){
    },
    SET_CONVERSATION_ANSWER(){
    },
    SET_EMAIL_VALIDATION(){
    },
    SET_OTP_VALIDATION(){
    },
    SET_NEW_PASSWORD_VALIDATION(){
    },
    DELETE_CONVERSATION(){
    },
  },
  actions: {
    async loginUser({ commit }, data) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      let response = await axios.post('validation', data, {headers: {'X-CSRFToken': csrfToken}});
      if(response && response.status == 200){
          commit("SET_AUTHENTICATED", true);
          sessionStorage.setItem('user_token', response.data.user_token)
          sessionStorage.setItem('contact_id', response.data.contact_id)
          return response;
      } else{
           alert("The credentials doesn't exist. Please check & try again.")
      }
    },
    logoutUser({ commit }) {
      commit("SET_AUTHENTICATED", false);
      commit("SET_ALL_CONVERSATIONS", []);
      commit("SET_SPECIFIC_CONVERSATION", []);
      sessionStorage.removeItem('user_token');
      sessionStorage.removeItem('contact_id');
      sessionStorage.removeItem('current_conversation_id')
    },
    async signUpUser({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      let response = await axios.post('signup', payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_SIGNUP", response.data);
      return response;
    },
    async fetchAllConversations({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      let response = await axios.post('conversations', payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_ALL_CONVERSATIONS", response.data);
      return response.data;
    },
     async fetchSpecificConversation({ commit }, id) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/conversation/${id}`, null, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_SPECIFIC_CONVERSATION", response.data.content);
      return response.data.content;
    },
    async fetchIframeProperties({ commit }) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      let response = await axios.post('iframe_properties', null, {headers: {'X-CSRFToken': csrfToken}});
      sessionStorage.setItem('chatbot_name', response.data.chatbot_name)
      commit("SET_IFRAME_PROPERTIES", response);
      return response;
    },
    async createConversationSummary({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/summary`, payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_CONVERSATION_SUMMARY", response);
      return response;
    },
    async createConversationAnswer({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name');
      let response = await fetch(`/${chatbot_name}/answer`, 
                                { method: 'POST', 
                                  responseType: 'stream', 
                                  body: JSON.stringify(payload), 
                                  headers: {
                                    'Content-Type': 'application/json',
                                    'X-CSRFToken': csrfToken
                                  }
                                }
                                );
      if (!response.ok) {
        let message = `Request failed with status ${response.status}`;
        try {
          const errorResponse = await response.json();
          message = errorResponse.Message || errorResponse.detail || message;
        } catch (error) {
          console.error('Unable to parse error response', error);
        }
        const requestError = new Error(message);
        requestError.status = response.status;
        throw requestError;
      }
      console.log('response_object', typeof response)
      commit("SET_CONVERSATION_ANSWER", response);
      return response;
    },
    async forgotPasswordEmailValidation({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/email_validation`, payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_EMAIL_VALIDATION", response);
      return response;
    },
    async otpValidation({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/otp_validation`, payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_OTP_VALIDATION", response);
      return response;
    },
    async newPasswordValidation({ commit }, payload) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/validate_new_password`, payload, {headers: {'X-CSRFToken': csrfToken}});
      commit("SET_NEW_PASSWORD_VALIDATION", response);
      return response;
    },
    async deleteConversationAction({ commit }, id) {
      const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
      const chatbot_name = sessionStorage.getItem('chatbot_name')
      let response = await axios.post(`/${chatbot_name}/delete_conversation/${id}`, {headers: {'X-CSRFToken': csrfToken}});
      commit("DELETE_CONVERSATION", response);
      return response;
    },
  },
});

export default store;
